var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"googleTranslateElement",attrs:{"id":"google_translate_element"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }